import React, { useState, useEffect } from 'react';
import { cn } from '@/utils/classnames';

interface CopyNotificationProps {
    message: string;
    onClose: () => void;
    duration?: number;
}

export const CopyNotification: React.FC<CopyNotificationProps> = ({
    message,
    onClose,
    duration = 2000
}) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Show notification
        setIsVisible(true);

        // Auto hide after duration
        const timer = setTimeout(() => {
            setIsVisible(false);
            setTimeout(onClose, 300); // Wait for animation to complete
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    return (
        <div
            className={cn(
                'fixed top-4 right-4 z-[100] bg-[#57E8BA] text-black px-4 py-3 rounded-lg shadow-lg font-medium text-sm transition-all duration-300 ease-in-out',
                isVisible
                    ? 'translate-x-0 opacity-100'
                    : 'translate-x-full opacity-0'
            )}
            onClick={() => {
                setIsVisible(false);
                setTimeout(onClose, 300);
            }}
        >
            <div className="flex items-center gap-2">
                <span className="text-lg">✓</span>
                <span>{message}</span>
            </div>
        </div>
    );
};

// Global notification state
let notificationCallback: ((message: string) => void) | null = null;

export const setNotificationCallback = (callback: ((message: string) => void) | null) => {
    notificationCallback = callback;
};

export const showCopyNotification = (message: string) => {
    if (notificationCallback) {
        notificationCallback(message);
    } else {
        console.warn('Copy notification callback not set');
    }
};
